/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  acceptInvitationApi,
  addMedicalHistoryApi,
  deleteInvitedUserApi,
  getDoctorDetailByIdApi,
  getInviteesApi,
  getMedicalHistoryApi,
  getPatientDetailByIdApi,
  getUsersApi,
  inviteUserApi,
} from "@/api/usersApi";
import Types from "../types";
import {
  AddMedicalHistory,
  DispatchType,
  UserFilterStateType,
  UserType,
} from "@/common/types";
import { setLoader } from "./commonActions";

export const getUsers = (
  filterState: UserFilterStateType,
  page?: number,
  pageSize?: number
) => {
  return async (dispatch: any) => {
    dispatch(setLoader(true));
    const result = await getUsersApi(
      filterState?.role?.value,
      filterState?.doctor,
      filterState?.search,
      page,
      pageSize
    );
    if (result) {
      dispatch({
        type: Types.SET_USERS,
        payload: result.data,
      });
    }
    dispatch(setLoader(false));
  };
};

export const getAllDoctors = (search: string = "") => {
  return async (dispatch: DispatchType) => {
    const result = await getUsersApi("doctor", "", search);
    if (result) {
      dispatch({
        type: Types.SET_DOCTORS,
        payload: result.data?.results || [],
      });
    }
  };
};

export const getAllPatients = (search: string = "") => {
  return async (dispatch: DispatchType) => {
    const result = await getUsersApi("patient", "", search);
    if (result) {
      dispatch({
        type: Types.SET_PATIENTS,
        payload: result.data?.results || [],
      });
    }
  };
};

export const getDoctorDetailById = (id: number) => {
  return async (dispatch: any) => {
    dispatch(setLoader(true));
    const result = await getDoctorDetailByIdApi(id);
    if (result) {
      dispatch({
        type: Types.SET_DOCTOR_DETAILS,
        payload: result.data,
      });
    }
    dispatch(setLoader(false));
  };
};

export const getPatientDetailById = (id: number) => {
  return async (dispatch: any) => {
    dispatch(setLoader(true));
    const result = await getPatientDetailByIdApi(id);
    if (result) {
      dispatch({
        type: Types.SET_PATIENT_DETAILS,
        payload: result.data,
      });
    }
    dispatch(setLoader(false));
  };
};

export const acceptInvitation = (
  token: string | null,
  password: string,
  callback: () => void
) => {
  return async (dispatch: any) => {
    try {
      dispatch(setLoader(true));
      await acceptInvitationApi(token || "", password);
      callback();
      dispatch(setLoader(false));
    } catch {
      dispatch(setLoader(false));
    }
  };
};

export const inviteUser = (
  state: UserType,
  callback: () => void = () => {}
) => {
  return async (dispatch: any) => {
    try {
      dispatch(setLoader(true));
      await inviteUserApi(state.name, state.email, state.role, state.doctor);
      callback();
      dispatch(setLoader(false));
    } catch {
      dispatch(setLoader(false));
    }
  };
};

export const getInvitees = () => {
  return async (dispatch: any) => {
    try {
      dispatch(setLoader(true));
      const result = await getInviteesApi();
      if (result) {
        dispatch({
          type: Types.SET_USERS,
          payload: result.data,
        });
      }
      dispatch(setLoader(false));
    } catch {
      dispatch(setLoader(false));
    }
  };
};

export const deleteInvitedUser = (userId: number) => {
  return async (dispatch: any) => {
    try {
      dispatch(setLoader(true));
      await deleteInvitedUserApi(userId);
      dispatch(getInvitees());
      dispatch(setLoader(false));
    } catch {
      dispatch(setLoader(false));
    }
  };
};

export const getMedicalHistory = (id: number) => {
  return async (dispatch: any) => {
    try {
      dispatch(setLoader(true));
      const result = await getMedicalHistoryApi(id);
      if (result) {
        dispatch({
          type: Types.SET_MEDICAL_HISTORY,
          payload: result.data,
        });
      }
      dispatch(setLoader(false));
    } catch {
      dispatch(setLoader(false));
    }
  };
};

export const addMedicalHistory = (
  medicalHistory: AddMedicalHistory,
  callback?: () => void
) => {
  return async (dispatch: any) => {
    try {
      dispatch(setLoader(true));
      const result = await addMedicalHistoryApi(medicalHistory);
      if (result) {
        dispatch(getMedicalHistory(medicalHistory.patient_id));
        if (callback) {
          callback();
        }
      }
      dispatch(setLoader(false));
    } catch {
      dispatch(setLoader(false));
    }
  };
};
